import {
  faExclamationCircle,
  faHome,
  faRefresh
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import logoUrl from '~/assets/job-explorer.svg'
import loginDrawUrl from '~/assets/login.svg'
import {
  aside,
  asideImage,
  asideTitle,
  container,
  main,
  mainImage
} from '~/pages/styles/Login.css'
import { themeClass } from '~/styles/theme.css'
import { InputCol } from '../Form'
import { ButtonGroup } from './Blocks/ButtonGroup/ButtonGroup'
import { NoResult } from './Elements/NoResult/NoResult'
import { Button } from './Interactions/Button'
export const GlobalError = ({ error }: { error?: unknown }): ReactElement => {
  return (
    <div className={clsx(themeClass, container)}>
      <main className={main}>
        <a href={'/'}>
          <h1 className={mainImage}>
            <img src={String(logoUrl)} alt="job explorer" />
          </h1>
        </a>
        <InputCol>
          <NoResult
            icon={faExclamationCircle}
            isError={true}
            message={`Une erreur ${error !== undefined ? 'interne' : 404} est survenue lors de votre navigation 🤕`}
          />
          <ButtonGroup align="center">
            <Button onClick={() => window.location.reload()}>
              <FontAwesomeIcon icon={faRefresh} />
              Recharger la page
            </Button>
            <Button
              onClick={() => {
                window.location.href = '/'
              }}
            >
              <FontAwesomeIcon icon={faHome} />
              Retour au tableau de bord
            </Button>
          </ButtonGroup>
          <div>
            <small>{error !== undefined ? String(error) : null}</small>
          </div>
        </InputCol>
      </main>
      <aside className={aside}>
        <h2 className={asideTitle}>
          Accompagner la croissance des professionnels du recrutement
        </h2>
        <img
          src={String(loginDrawUrl)}
          alt="Logo de job explorer"
          className={asideImage}
        />
      </aside>
    </div>
  )
}
